
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[site]/help/contacts",
      function () {
        return require("private-next-pages/_sites/[site]/help/contacts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_sites/[site]/help/contacts"])
      });
    }
  